import React from "react";
import { Modal } from "antd";
import { redirectToStore } from "../../Utils/genralUtility";

const DownloadAppModal = (props) => {
  const { isOpen, onClose } = props;

  return (
    <Modal open={isOpen} onCancel={onClose} centered style={{ padding: 0 }} footer={[]}>
      <div className=" flex flex-col gap-2">
        <div className=" border-b-2 border-b-gray-200 flex flex-col gap-2 py-2">
          <h1 className=" text-xl font-bold tracking-tight">
            {" "}
            Unlock Full Access
          </h1>
          <p className="text-lg tracking-tighter leading-snug">
            To use all features, please download our mobile app from the store.
          </p>
        </div>
        <button type="button" 
        onClick={()=>redirectToStore("download_app_modal")}
        className=" bg-teal-600 py-3 px-6 text-white text-lg font-medium rounded-xl">
          Download App
        </button>
      </div>
    </Modal>
  );
};

export default DownloadAppModal;
